var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71387 6H22.2853",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28613 6H19.7147V21.4286C19.7147 21.8832 19.5341 22.3193 19.2126 22.6408C18.8911 22.9622 18.4551 23.1429 18.0004 23.1429H6.00042C5.54576 23.1429 5.10973 22.9622 4.78824 22.6408C4.46674 22.3193 4.28613 21.8832 4.28613 21.4286V6Z",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71387 6.00003V5.14289C7.71387 4.00625 8.1654 2.91616 8.96912 2.11243C9.77285 1.30871 10.8629 0.857178 11.9996 0.857178C13.1362 0.857178 14.2263 1.30871 15.03 2.11243C15.8338 2.91616 16.2853 4.00625 16.2853 5.14289V6.00003",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42871 11.1453V18.005",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5713 11.1453V18.005",
    stroke: "#0CAF6D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.2547c35dddd75cdf34f23b3d4d90fa75.svg";
export { ForwardRef as ReactComponent };